<template>
  <div class="rates">
    <template v-if="rates.length">
      <p class="p">
        Seleccioná la opción de hotel/es a reservar, y los tipos de habitación/es para cada
        hotel. Una vez tengas habitación para todos tus pasajeros, presioná en
        <strong>"continuar"</strong> para ir al siguiente paso.
      </p>
      <div class="rates-content">
        <collapse
          v-for="(rate, i) in rates"
          class="rate-collapse"
          :key="i"
          closed
        >
          <div
            slot="trigger"
            class="rate-title"
          >
            <h3 class="rate-name">
              {{ rate.detail }}
            </h3>
            <h4 class="rate-initial-price">
              {{ occupation }} LUGAR{{ occupation > 1 ? 'ES' : '' }}
            </h4>
          </div>
          <div
            slot="content"
            class="rate-hotels"
          >
            <template
              v-if="
                rate.availability == 1 &&
                  Object.values(rate.rooms).every(room =>
                    rate.hotels.every(hotel =>
                      hotel.rooms.find(r => r.name == room.name)
                    )
                  )
              "
            >
              <div
                class="rate-hotel d-inline-block w-auto mr-3 mb-2"
                v-for="hotel in rate.hotels"
                :key="hotel.id"
              >
                <h4 class="rate-hotel-name">
                  {{ hotel.name }}
                </h4>
                <star
                  v-for="star in hotel.stars"
                  :key="star"
                />
              </div>
              <div
                class="rate-hotel w-100"
                key="h"
              >
                <div class="d-flex">
                  <div
                    v-for="(room, str) in rate.rooms"
                    class="rate-room mr-3 text-center"
                    :key="str"
                  >
                    <h4 class="rate-room-name">
                      {{ room.name }}
                    </h4>
                    <counter
                      :incrementer="
                        Object.values(rate.rooms).reduce(
                          (a, b) => a + b.qty * b.capacity,
                          room.capacity
                        ) <= occupation
                      "
                      v-model="rate.rooms[str].qty"
                      @add="add(room)"
                      @sub="sub(str)"
                    />
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <h2 class="rate-msg">
                La tarifa no tiene alojamiento disponible.
              </h2>
              <p class="rate-msg">
                Comuniquese con nosotros para consultar la disponibilidad
              </p>
            </template>
          </div>
        </collapse>
      </div>
    </template>
    <template v-else>
      <div class="py-5">
        <h2 class="txt-center">
          No hay tarifas disponibles para la salida.
        </h2>
        <p class="rate-msg">
          Comuniquese con nosotros para consultar la disponibilidad.
        </p>
      </div>
    </template>
    <div class="txt-right py-2 border-top my-3">
      <btn
        color="white"
        size="xs"
        @click="$emit('close')"
      >
        CANCELAR
      </btn>
      <btn
        v-if="$store.state.user.host && rates.length && !disabled"
        color="grey"
        size="xs"
        @click.prevent="next('booking/ASSIGN')"
      >
        BLOQUEAR
      </btn>
      <btn
        v-if="rates.length && !disabled"
        color="orange"
        size="xs"
        @click.prevent="next()"
      >
        CONTINUAR
      </btn>
    </div>
  </div>
</template>
<script>
import Collapse from '@/components/Collapse'
import Counter from '@/components/Counter'
import Btn from '@/components/Btn'
import Star from '@/components/Star'
import swal from 'sweetalert2'
import { clone, UID } from '@/utils'
import { PASSENGER_TYPES } from '@/constans'
import { ROOMING, RATE, STATUS } from '@/store/mutations'

export default {
  props: ['departure'],
  components: {
    Star,
    Btn,
    Counter,
    Collapse
  },

  methods: {
    sub (slug) {
      const i = this.rooming.findIndex(r => r.slug == slug)
      if (i >= 0) {
        this.rooming.splice(i, 1)
      }
    },
    add (room) {
      this.rates.forEach((rate, i) => {
        if (rate.id != room.rate_id) {
          Object.keys(rate.rooms).forEach(k => {
            this.rates[i].rooms[k].qty = 0
          })
        }
      })

      room.tmp_id = UID()

      this.rooming = [clone(room)].concat(this.rooming.filter(r => r.rate_id == room.rate_id))
    },
    next (ASSIGN) {
      var rate = this.rates.find(
        rate =>
          Object.values(rate.rooms).reduce(
            (val, room) => val + room.qty * room.capacity,
            0
          ) === this.occupation
      )

      this.$store.commit('booking/' + ROOMING, this.rooming)
      this.$store.commit('booking/' + RATE, rate)

      if (ASSIGN) {
        this.$store.dispatch('booking/ASSIGN')
      } else {
        this.$store.dispatch('booking/SEATING').then(() => {
          this.$store.commit('booking/' + STATUS, 'rooming')
        })
      }
    },
    _sub (room, rate, hotel) {
      this.rates
        .find(r => r.id == rate.id)
        .selection.find(h => h.id == hotel.id)
        .rooms.some((r, i, rooms) => (r.id == room.id ? rooms.splice(i, 1) : false))
    },
    _add (room, rate, hotel) {
      if (
        room.base == 'single' &&
				this.$store.state.booking.passengers.some(
				  passenger => passenger.type == PASSENGER_TYPES.kids.str
				)
      ) {
        swal({ type: 'info', title: 'Solo los adultos pueden ir en habitaciones single.' })
      }
      this.rates
        .find(r => r.id == rate.id)
        .selection.find(h => h.id == hotel.id)
        .rooms.push({ id: room.id, x: room.capacity })
    },
    _next (action) {
      var rate = this.rates
        .map(rate => ({
          id: rate.id,
          hotels: rate.selection
            .filter(hotel => hotel.rooms.length)
            .map(hotel => ({
              id: hotel.id,
              rooms: hotel.rooms.map(room => room.id)
            }))
        }))
        .find(rate => rate.hotels.length)

      this.$store.dispatch(action, rate)
    }
  },

  computed: {
    occupation () {
      return this.$store.state.booking.passengers.filter(
        p => ![PASSENGER_TYPES.infoas.str, PASSENGER_TYPES.infoascb.str].includes(p.type)
      ).length
    },
    disabled () {
      const occupation = this.occupation
      return (
        this.rates
          .map(rate =>
            Object.values(rate.rooms).reduce(
              (val, room) => val + room.qty * room.capacity,
              0
            )
          )
          .filter(n => n === occupation).length !== 1
      )
    }
  },

  data () {
    const departure = clone(this.departure)
    const passengers = clone(this.$store.state.booking.passengers)
    const rates = departure.rates
      .filter(rate => rate.hotels.every(hotel => hotel.rooms.length))
      .map(rate => {
        const rooms = rate.hotels
          .reduce((rooms, hotel) => rooms.concat(hotel.rooms), [])
          .map(room => {
            room.slug = room.name
              .toLowerCase()
              .replace(/-+/g, '')
              .replace(/\s+/g, '-')
              .replace(/[^a-z0-9-]/g, '')
            return room
          })
          .sort((a, b) => a.capacity - b.capacity)

        rate.rooms = rooms.reduce(
          (rooms, { name, available, base, capacity, slug, icon }, idx, src) => {
            rooms[slug] = {
              name,
              rate_id: rate.id,
              available,
              base,
              capacity,
              icon,
              slug,
              qty: 0,
              passengers: [],
              rooms: src.filter(room => room.slug == slug).map(room => room.id)
            }
            return rooms
          },
          {}
        )

        return rate
      })

    return {
      passengers,
      rooming: [],
      rates
    }
  }
}
</script>
